<template>
  <div class="content">
    <h2 style="margin:20px">问诊大厅</h2>
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <!-- <el-form-item>
                        <el-button
                          :loading="downloadLoading"
                          type="primary"
                          icon="el-icon-document"
                          @click="handleDownload"
                          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
                        >
      </el-form-item>-->
      <el-form-item label="患者问题搜索: " style="margin-left: 20px">
        <el-input v-model="selectForm.message" placeholder="请输入" style="width: 250px" clearable></el-input>
      </el-form-item>

      <el-form-item label="患者会话手机号: " style="margin-left: 20px">
        <el-input v-model="selectForm.phone" placeholder="请输入" style="width: 250px" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="患者下单手机号: " style="margin-left: 20px">
        <el-input v-model="selectForm.pay_phone" placeholder="请输入" style="width: 250px" clearable></el-input>
      </el-form-item>-->
      <el-form-item label="医生账号: " style="margin-left: 20px" v-if="roleId !== 3">
        <el-input
          v-model="selectForm.sup_username"
          placeholder="请输入"
          style="width: 250px"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="是否付费: ">
        <el-select v-model="selectForm.isPay" placeholder="请选择" clearable>
          <div v-for="item in isPayList" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="提问状态: ">
                        <el-select v-model="selectForm.state" placeholder="请选择" clearable>
                          <div v-for="item in doctorList" :key="item.id">
                            <el-option :label="item.name" :value="item.id"></el-option>
                          </div>
                        </el-select>
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div class="tableBox">
      <ElTable
        height="calc(100vh - 300px)"
        :columns="listHeader"
        :tableData="dataList"
        :loading="loading"
        :total="listQuery.total"
        :listQuery="listQuery"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="name" slot-scope="{ row }">
          <span>{{ row.name ? row.name : "-" }}</span>
        </template>

        <template slot="message" slot-scope="{ row }">
          <el-popover trigger="hover" placement="top">
            <p style="text-align: center; max-width: 300px">
              <span style="color: rgb(59, 59, 59); font-weight: 600">{{ row.message }}</span>
            </p>
            <div
              slot="reference"
              class="name-wrapper addressDetail"
            >{{ row.message ? row.message : "-" }}</div>
          </el-popover>
        </template>

        <template slot="phone" slot-scope="{ row }">
          <span>{{ row.phone ? row.phone : "-" }}</span>
        </template>

        <template slot="money" slot-scope="{ row }">
          <span>{{ row.money ? row.money : "-" }}</span>
        </template>

        <template slot="sup_username" slot-scope="{ row }">
          <span>{{ row.sup_username ? row.sup_username : "暂无医生接单" }}</span>
        </template>

        <template slot="pay_phone" slot-scope="{ row }">
          <span>{{ row.pay_phone ? row.pay_phone : "-" }}</span>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <el-button size="mini" @click="detailsBtn(row)" type="text">详情</el-button>
          <el-button size="mini" @click="handleFenpei(row)" v-if="roleId !== 3" type="text">分配医生</el-button>
          <el-button
            style="margin: 10px 10px"
            size="mini"
            @click="handleJiedan(row)"
            v-if="roleId == 3"
            type="text"
          >接单</el-button>
          <el-button
            size="mini"
            @click="deleteBtn(row)"
            :disabled="isRole"
            v-if="roleId !== 3"
            type="text"
            style="color: red"
          >删除</el-button>
        </template>
      </ElTable>
    </div>

    <!-- 详情:回复,推荐用药,上传图片 -->
    <el-dialog
      title="详情"
      :visible.sync="detailsVisible"
      :close-on-click-modal="false"
      top="0"
      :fullscreen="true"
    >
      <h3>流水ID:{{ form.answerNumber }}</h3>
      <!-- 1.文字 2.选项 3.图片 4.推荐用药 -->
      <div class="box" ref="box">
        <div v-for="(item, index) in tableData" :key="index">
          <div class="person-one" v-if="item.userRole == 0">
            <div class="message">
              <div style="margin: 0px 0 10px">患者{{ item.phone }} 问：</div>
              <div v-if="item.msgType == 3">
                <el-image
                  style="width: 60px; max-height: 60px"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                ></el-image>
              </div>
              <div v-if="item.msgType == 1">{{ item.message }}</div>
            </div>
            <div style="margin: 10px 0 0px">提问时间： {{ item.createTime }}</div>
          </div>
          <div class="person-two" v-else>
            <div class="message">
              <div style="margin: 0px 0 10px">
                {{ item.userRole == 1 ? "机器人" : "医生" }}
                {{ item.msgType == 4 ? "推荐商品" : "回复" }} ：
              </div>
              <!-- <div v-if="item.msgType == 1 && item.userRole === 2">
                {{ item.message }}
              </div>-->
              <div v-if="item.msgType == 1" style="font-size: 12px; margin: 10px 0 20px">
                <div v-if="typeof item.message.content === 'object'">
                  <div>{{ item.message.title ? item.message.title : "" }}</div>
                  <p style="white-space: pre-line">{{ item.message.content[0] }}</p>
                </div>
                <div v-else>{{ item.message }}</div>
              </div>

              <div v-if="item.msgType == 3">
                <el-image
                  style="width: 60px; max-height: 60px"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                ></el-image>
              </div>

              <div v-if="item.msgType == 2">
                {{ item.message.title?item.message.title:'' }}
                <div v-for="(item, index) in item.message.content" :key="index">
                  <div style="font-size: 12px; margin: 10px 0 20px">
                    {{ item.title }}：
                    {{ item.answer ? item.answer : "暂无回答" }}
                    <div v-if="item.answerImg">
                      <el-image
                        style="width: 60px; max-height: 60px"
                        :src="item.answerImg"
                        :preview-src-list="[item.answerImg]"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.msgType == 4">
                <div v-for="(item, index) in item.message.content" :key="index">
                  <div style="font-size: 15px; margin: 10px 0 10px">{{ item.productName }}</div>
                </div>
              </div>

              <!-- 综合问答 -->
              <div v-if="item.msgType == 5">
                <div
                  v-for="(msgItem, msgIndex) in (Array.isArray(item.message) ? item.message : [])"
                  :key="msgIndex"
                >
                  <!-- type: text - 直接渲染文本 -->
                  <div
                    v-if="msgItem.type === 'text'"
                    style="font-size: 12px; margin: 10px 0 20px; white-space: pre-line;"
                  >{{ msgItem.data }}</div>

                  <!-- type: product - 渲染产品图片 -->
                  <div v-else-if="msgItem.type === 'product'" style="margin: 10px 0 20px;">
                    <div
                      v-for="(product, pIndex) in (Array.isArray(msgItem.data) ? msgItem.data : [])"
                      :key="pIndex"
                      style="margin-bottom: 10px;"
                    >
                      <el-image
                        v-if="product.coverImg"
                        style="width: 100px; max-height: 100px; margin-right: 10px;"
                        :src="product.coverImg"
                        :preview-src-list="[product.coverImg]"
                      ></el-image>
                      <div style="font-size: 12px;">{{ product.productName }}</div>
                    </div>
                  </div>

                  <!-- 其他 type - 渲染文本 -->
                  <div
                    v-else
                    style="font-size: 12px; margin: 10px 0 20px; white-space: pre-line;"
                  >{{ typeof msgItem.data === 'string' ? msgItem.data : JSON.stringify(msgItem.data) }}</div>
                </div>
              </div>
            </div>
            <div style="margin: 10px 0 0px">时间：{{ item.createTime }}</div>
          </div>
        </div>
        <el-empty description="暂无聊天记录" v-if="tableData.length === 0"></el-empty>
      </div>
      <div class="btnList">
        <!-- <el-button
          type="primary"
          size="small"
          v-waves
          @click="handleAdd"
          style="margin:0 20px 0 0"
          >回复</el-button
        >-->
        <el-button @click="detailsVisible = false">关闭页面</el-button>
      </div>
    </el-dialog>
    <!-- 回复 -->
    <el-dialog title="回复患者" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="内容" required>
          <el-input
            type="textarea"
            clearable
            v-model="dialogForm.message"
            :rows="5"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分配医生 -->
    <el-dialog title="分配医生" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="患者提问" :label-width="formLabelWidth">
          <el-input v-model="form.message" auto-complete="off" disabled type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="医生列表: " style="margin-left: 20px">
          <el-select v-model="form.adminId" placeholder="请选择">
            <el-option
              v-for="item in doctorList"
              :label="item.message"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="检测结果(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.result"
            auto-complete="off"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import {
  selectRecordList,
  selectRecordDetails,
  deleteRecord,
  updateRecord
} from "@/services/answers/record.js";
import { selectspuser } from "@/services/system/admin.js";

export default {
  components: {
    ElTable
  },
  data() {
    return {
      tableData: [],
      roleId: "",
      selectForm: {},
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: ""
      },
      dialogForm: {},
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      detailsVisible: false,
      dialogVisible: false,
      isRole: false,
      //1待邮寄 2已邮寄 3已送检 4检测完成
      doctorList: [],
      formLabelWidth: "100px",
      isPayList: [
        { id: 0, name: "全部" },
        { id: 1, name: "未付费" },
        { id: 2, name: "已付费" }
      ],
      listHeader: [
        { label: "序号", type: "index", width: "50", align: "center" },
        {
          label: "流水ID",
          prop: "answerNumber",
          width: "150",
          align: "center"
        },
        {
          label: "提问时间",
          prop: "createTime",
          width: "180",
          align: "center"
        },
        { label: "患者姓名", slots: "name", width: "150", align: "center" },
        { label: "患者提问", slots: "message", width: "250", align: "center" },
        {
          label: "患者会话手机号",
          slots: "phone",
          width: "150",
          align: "center"
        },
        {
          label: "患者下单手机号",
          slots: "pay_phone",
          width: "150",
          align: "center"
        },
        { label: "付费金额", slots: "money", width: "150", align: "center" },
        {
          label: "所属医生账号",
          slots: "sup_username",
          width: "130",
          align: "center"
        },
        {
          label: "操作",
          slots: "operation",
          width: "160",
          align: "center",
          fixed: "right"
        }
      ]
    };
  },
  async created() {
    let result = await selectspuser({ roleId: 3 });
    this.doctorList = result;
    if (this.$store.state.supUser.roleId == 3) {
      this.selectForm.adminId = this.$store.state.supUser.id;
      this.roleId = 3;
    }

    this.select();
  },
  methods: {
    select() {
      // 查询提问数据
      this.loading = true;
      selectRecordList({
        ...this.selectForm,
        isAdminId: this.$store.state.supUser.roleId == 3,
        adminId: "",
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize
      }).then(resp => {
        this.dataList = resp.data || [];
        this.listQuery.total = resp.count || 0;
        this.loading = false;
      });
    },

    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.select();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.listQuery.pageNumber = 1;
      this.select();
    },

    selectBtn() {
      this.select();
    },

    // 接单
    handleJiedan(row) {
      updateRecord({
        ...row,
        adminId: this.$store.state.supUser.id,
        phoneAnswer: this.$store.state.supUser.supplier_phone
      }).then(resp => {
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogFormVisible = false;
          this.select();
        }
      });
    },

    /* 详情 */
    detailsBtn(row) {
      this.form = JSON.parse(JSON.stringify(row));
      selectRecordDetails({ answerNumber: row.answerNumber }).then(res => {
        this.tableData = res.data.map(item => {
          if (
            item.msgType == 2 ||
            item.msgType == 4 ||
            item.msgType == 5 ||
            ((item.userRole === 1 || item.userRole === 2) && item.msgType == 1)
          ) {
            try {
              item.message = JSON.parse(item.message);
            } catch (e) {
              item.message = item.message;
            }
          }
          return item;
        });
        this.detailsVisible = true;
      });
    },

    // 分配弹窗
    handleFenpei(row) {
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 提交表单按钮
    updateBtn() {
      // console.log("点击了确认", this.form);
      updateRecord({
        ...this.form
      }).then(resp => {
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogFormVisible = false;
          this.select();
        }
      });
    },

    deleteBtn(row) {
      this.$confirm("此操作将永久删除该提问, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteRecord({ answerNumber: row.answerNumber }).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
    },

    save() {
      //必填字段校验
      if (!this.dialogForm.message) {
        this.$message.error("请填写必填字段");
        return;
      }
    },

    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then(excel => {
        const tHeader = [
          "id",
          "提问号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "提问总价",
          "物流单号",
          "提问状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "提问时间"
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "state",
          "productList",
          "createTime"
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map(item => {
          const product = item.productList.map(item2 => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(",")
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "提问列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.content {
  margin: 10px auto;
  width: 98%;
}
.tableBox {
  height: calc(100vh - 250px);
  overflow-y: auto;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}

.addressDetail:hover {
  cursor: pointer;
}

.addressDetail {
  width: 140px;
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

h3 {
  margin: 0 0 20px;
  font-size: 16px;
}

.box {
  padding: 20px;
  margin: 0 auto;
  width: 95%;
  height: calc(100vh - 250px);
  overflow-y: auto;
  line-height: 26px;
}

.message {
  color: 111;
  font-size: 16px;
}

.person-one {
  background: rgba(230, 230, 230, 1);
  padding: 20px 30px;
  border-radius: 20px;
  margin: 10px 0;
}

.person-two {
  background: rgb(255, 255, 255);
  border: 1px solid rgba(230, 230, 230, 1);
  padding: 20px 30px;
  border-radius: 20px;
  margin: 10px 0;
}

.btnList {
  display: flex;
  margin: 20px auto;
  justify-content: center;
  button {
    margin: 0 10px;
  }
}
</style>
